import { Component, defineComponent } from '@decify/cell-shopify/client';
import './TabsTrigger.scss';
export const tabsTriggerName = 'TabsTrigger';
export const tabsTriggerTagName = 'cell-component-tabs-trigger';
export const tabsTriggerClickEvent = 'click';
export class TabsTrigger extends Component {
    classNames = {
        active: 'TabsTrigger--Active',
    };
    elements;
    constructor() {
        super(tabsTriggerName);
        this.validateProps(['index']);
        const buttonElement = this.querySelector('.TabsTrigger__Button');
        if (!buttonElement) {
            throw new Error('Button element not found');
        }
        this.elements = {
            button: buttonElement,
        };
        this.handleClick = this.handleClick.bind(this);
    }
    componentDidMount() {
        this.elements.button.subscribe('click', this.handleClick);
    }
    handleClick() {
        this.publish(tabsTriggerClickEvent, {
            index: this.props.index,
        });
    }
    setActive() {
        this.classList.add(this.classNames.active);
    }
    setInactive() {
        this.classList.remove(this.classNames.active);
    }
}
defineComponent(tabsTriggerTagName, TabsTrigger);
